module.exports = __webpack_public_path__ + "img/calendar.cc1198c1.svg";